import Action from 'redux/helpers/createAction'
const name = 'search'

export const setValue = Action(name + '/SET_VALUE', value => ({
  value
}))
export const setType = Action(name + '/SET_TYPE', type => ({
  type
}))
export const setLocation = Action(name + '/SET_LOCATION', (location, languages, language) => ({
  location, languages, language
}))
export const setLanguages = Action(name + '/SET_LANGUAGE', (languages, language) => ({
  languages, language
}))
export const setLanguage = Action(name + '/SET_LANGUAGE', language => ({
  language
}))
export const setDevice = Action(name + '/SET_DEVICE', device => ({
  device
}))
export const setDepth = Action(name + '/SET_DEPTH', depth => ({
  depth
}))
export const setError = Action(name + '/SET_ERROR', error => ({
  error
}))
export const setSearch = Action(name + '/SET_ALL', payload => ({
  payload
}))
